import React, { memo } from 'react';
import { LoanService } from '../../services';
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import WatchLater from '@material-ui/icons/WatchLater';
import { useError } from '../../contexts/ErrorContext';

const AddMarkAsProcessingButton = ({selectedRowIndices, payments}) => {
    const { showError } = useError();
    const selectedPaymentIds = selectedRowIndices.map(rowId => payments[rowId].id);
    const handleProcessingClick = () => {
        LoanService.markPaymentsAsProcessing(selectedPaymentIds).then(response => {
            // !FIXME: Do this better!
            window.location.reload();
        }).catch(showError);
    }

    return (
        <Tooltip title={`Mark Payments as 'Processing'`}>
            <IconButton onClick={handleProcessingClick}>
              <WatchLater />
            </IconButton>
        </Tooltip>
    );
}

export default memo(AddMarkAsProcessingButton);
